<template>
    <div>
        <e-step :stepData="stepData" :activeStep="activeStep"/>
        <div class="detail-wrapper">
            <img :src="imgUrl" alt="" class="img-wrapper">
            <tip-message :tipData="tipData" class="tip-wrapper"/>
        </div>
        <div class="flex-c">
            <el-button style="width:60px" type="primary" plain @click="toPath">关闭</el-button>
        </div>
    </div>
</template>

<script>
    import eStep from './e-steps';
    import tipMessage from './tipMessage';
    export default {
        name: "merchantAuthentication",
        components:{eStep,tipMessage},
        data(){
            return{
                tipData:[
                    {title:'温馨提示'},
                    {title:'1.请使用支付宝扫描二维码，在手机端完成商家认证和授权'},
                    {title:'2.完成后预计1小时后可二维码支付收款'},
                    {title:'3.具体操作指引详见',flag:'down',downloadURL:'',downLoadTitle:''},
                ],
                stepData:[
                    {title:'申请开通',},
                    {title:'商家认证',},
                ],
                activeStep:2,
                payWay:'',//微信 10 ；支付宝 20
                imgUrl :'',
                alipayAuthorization:require('../../../../../assets/img/pay/alipayAuthorization.png'),
                weChatAuthorization:require('../../../../../assets/img/pay/weChatAuthorization.png'),
            }
        },
        mounted(){
            this.payWay = Number(this.$route.query.payWay);
            this.tipData[3].payWay = this.payWay;
            if(this.payWay === 10){
                this.imgUrl = this.weChatAuthorization;
                this.tipData[3].downLoadTitle = '微信实名验证操作指引.pdf';
            }else{
                this.imgUrl = this.alipayAuthorization;
                this.tipData[3].downLoadTitle = '支付宝实名验证操作指引.pdf';
            }
        },
        methods:{
            toPath(){
                this.$router.push({ path: "/scanCodePayManagement" })
            },
        },
    }
</script>

<style scoped lang="scss">
    .detail-wrapper{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
        .img-wrapper{
            width: 200px;
            margin-right: 20px;
            box-shadow:  0px 0px 10px #7880A14D;
        }
        .tip-wrapper{
            width: 388px;
            font-size: 12px;
            height: 124px;
        }
    }

</style>